// src/AppRouter.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Contacto from './pages/Contacto';
import Ubicacion from './pages/Ubicacion';
import Certificados from './pages/Certificados';
import Nosotros from './pages/Nosotros';
import Aviso from './pages/Aviso';
import Estudios from './pages/Estudios';
import Header from './components/Header';
import Footer from './components/Footer';

const AppRouter = () => (
  <Router>
    <Header />
    <main>
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route path="/contacto" element={<Contacto />} />
      <Route path="/ubicacion" element={<Ubicacion />} />
      <Route path="/certificados" element={<Certificados />} />
      <Route path="/nosotros" element={<Nosotros />} />
      <Route path="/aviso" element={<Aviso />} />
      <Route path="/estudios" element={<Estudios />} />
    </Routes>
    </main>
    <Footer />
  </Router>
);

export default AppRouter;
